import { render } from "./UserRhrChart.vue?vue&type=template&id=1afd8315&scoped=true"
import script from "./UserRhrChart.vue?vue&type=script&lang=js"
export * from "./UserRhrChart.vue?vue&type=script&lang=js"

import "./UserRhrChart.vue?vue&type=style&index=0&id=1afd8315&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd8315"]])

export default __exports__